import React from "react"
import Layout from "../components/Layout"

const copy = {
  en: {
    heading: "Connect with Locals",
    p1:
      "Having local friends makes a big difference when you’re learning about the process of coming to Canada. They can explain how the system works, what is important in your application, where to find services and facilities, and share everyday tips. They can also introduce you to others who can help—from filling in forms and answering questions about Canada to connecting with people on a similar journey.",
    p2:
      "Across the country, many people are eager to meet you. They are volunteers from local churches who want to help newcomers settle into their new home in Canada. They’re happy to connect in person, by phone, or through video—whatever works best for you.",
    hero_alt: "Local friends meeting at a cafe",
    cta_text: "Click here to meet with people in the church near you",
    section2_title: "Local churches: who are they and what do they do?",
    s2_p1:
      "Church communities in Canada meet regularly, but each one is different in style, traditions, and activities. Even the places they gather vary: some meet in traditional church buildings, some in modern spaces, and others in community halls or schools.",
    s2_p2:
      "Most churches gather on Sundays for worship, prayer, and learning about Christian faith. Many also meet in smaller groups during the week. Every church is unique, but common activities include:",
    bullets: [
      "Reading the Bible and praying together",
      "Social activities (e.g., camps), parent-and-child groups, and language groups where newcomers can practise English",
      "Caring for people in need (e.g., food banks), community projects, and support groups for those facing challenges",
      "Visiting one another’s homes and sharing meals together",
    ],
    s2_p3:
      "Churches welcome and support everyone. Across Canada, many have joined the Welcome Network to greet newcomers, refugees, and migrants from every background. You don’t need to be a Christian to join—everyone is welcome! Find a Welcome Church near you and discover how they can help you build friendships and settle into life in Canada.",
    stack_alt1: "Small group meeting",
    cta2_text: "Click here to connect with a church near you",
  },
  cn: {
    heading: "本地聯絡",
    p1:
      "在了解移居加拿大的過程中，本地朋友能帶來很大幫助。他們可以解釋制度如何運作、申請中要注意的事項、各類服務與設施，並分享日常生活貼士。他們也能介紹你認識其他能夠幫忙的人——從填表、解答關於加拿大的問題，到與同路人建立連結，一起走這段旅程。",
    p2:
      "在全國各地，有許多人樂意與你相識。他們是來自教會的義工，盼望幫助新移民在加拿大的新家安頓。他們很樂意透過面對面、電話或視訊，以你最方便的方式與你聯繫。",
    hero_alt: "本地朋友在咖啡店見面",
    cta_text: "按此聯絡你附近的教會",
    section2_title: "本地教會：他們是誰？會做些甚麼？",
    s2_p1:
      "加拿大的教會群體會定期聚會，但在風格、傳統和活動上各有不同。聚會地點也很多元：有傳統教堂、現代化建築，或在社區禮堂、學校聚會。",
    s2_p2:
      "教會通常在主日一同敬拜、禱告，並學習基督信仰；平日也常有小組活動。每間教會都各有不同，但常見的活動包括：",
    bullets: [
      "一起讀聖經和禱告",
      "社交活動（如營會）、親子小組，以及幫助新移民練習英語的語言小組",
      "關顧有需要的人（如食物銀行）、社區參與計劃，以及為面對困難的人提供支援小組",
      "彼此到家中作客，一同分享餐點",
    ],
    s2_p3:
      "教會歡迎並支持每一位。在加拿大，許多教會已加入 Welcome Network，向任何國籍和背景的新移民、難民與移工伸出援手。你毋須是基督徒也可以參加——人人皆受歡迎！尋找你附近的 Welcome Church，看看他們如何幫助你結交朋友並在加拿大安居。",
    stack_alt1: "小組聚會",
    cta2_text: "按此聯絡你附近的教會",
  },
}

const Local = ({ lang = "en" }) => {
  const t = k => copy[lang][k]
  const isChinese = lang === "cn"

  return (
    <Layout lang={lang}>
      <section className="index__section local" data-lang={lang}>
        {/* Row 1: heading + 2 paragraphs (left), illustration (right) */}
        <div className="index__item index__item--two">
          <div className="local__content">
            <h2>{t("heading")}</h2>
            <p>{t("p1")}</p>
            <p>{t("p2")}</p>
          </div>

          <div
            className="index__media o__connect_local"
            role="img"
            aria-label={t("hero_alt")}
          />
        </div>

        {/* CTA: centered pill box */}
        <div className="index__cta index__cta--center">
          <div className="cta__box">
            <a
              href={isChinese ? "/cn/connect/" : "/connect/"}
              className="cta__link"
            >
              {t("cta_text")}
            </a>
          </div>
        </div>

        <div className="index__divider" />

        {/* Row 2: stacked photos (left), copy + bullets (right) */}
        <div className="index__item index__item--two">
          <div
            className="index__media index__media--stack o__church_group_1"
            role="img"
            aria-label={t("stack_alt1")}
          />

          <div className="local__content">
            <h2>{t("section2_title")}</h2>
            <p>{t("s2_p1")}</p>
            <p>{t("s2_p2")}</p>
            <ul className="step__list">
              {copy[lang].bullets.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p>{t("s2_p3")}</p>
          </div>
        </div>

        {/* CTA 2: centered pill box spanning the page */}
        <div className="index__cta index__cta--center">
          <div className="cta__box">
            <a
              href={isChinese ? "/cn/connect/" : "/connect/"}
              className="cta__link"
            >
              {t("cta2_text")}
            </a>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Local
